import { formatMoney, quickBuy } from "../components/utilities";
import Store from '../components/store'

const HeaderCart = {
  cartCount: {
    selector: '[data-cart-count]',
    attr: '[data-cart-count-attr]',
    text: '[data-cart-item-text]'
  },
  updateCartCount: function (_itemsCount) {
    var _this = this;
    
    $('.action.-cart .count').removeClass('hidden');
    $(HeaderCart.cartCount.attr).data('cart-count-attr', _itemsCount);
    $(HeaderCart.cartCount.attr).attr('data-cart-count-attr', _itemsCount);

    if (_itemsCount) {
      if (_itemsCount.items_count > 0) {
        $('.action.-cart .count').removeClass('hidden');
        $(HeaderCart.cartCount.attr).html(_itemsCount.items_count);
        $(HeaderCart.cartCount.text).html(_itemsCount.items_count);
      } else {
        $(HeaderCart.cartCount.attr).html(0);
        $(HeaderCart.cartCount.text).html(0);
      }
  
      if (_itemsCount > 0) {
        $('[data-cart-body]').parent().addClass('active');
      } else {
        $('[data-cart-body]').parent().removeClass('active');
      }
    }
  },
  loadCart: function (total) {
    const _this = this;
    const $boxCart = $('[data-cart-body]');
  
    HeaderCart.updateCartCount(total);

    vnda.loadCartPopup(function (html) {
      $boxCart.empty();
      $boxCart.append(html);

      
      // Atualiza shipping bar
      HeaderCart.shippingBar();
      
      // Carrega carrossel de brindes
      HeaderCart.setGiftsSwiper();
      
      // Seta novamente a compra rápida
      quickBuy();

      // Atualiza carrinho
      HeaderCart.setModal();
    });
  },
  show: function () {
    var $cartBody = $('[data-cart-body]');

    $cartBody.addClass('active');
  },
  updateItem: function (_itemId, _newQty, _$item, updateItemResult) {
    var _this = this;
    var _result;

    if( !_$item.hasClass('updating') ) {
      $.ajax({
        url: "/carrinho",
        type: "POST",
        dataType: 'json',
        data: {
          '_method': 'patch',
          'item_id': _itemId,
          'quantity': _newQty
        },
        beforeSend: function() {
          _$item.addClass('updating');
        }
      })
      .done(function(_cart) {
        // console.log('Item updated');
        
        let $product_popup = $('.product-popup');
        $product_popup.addClass('-active');
        setTimeout(() => {
          $product_popup.addClass('-inactive');
          
          setTimeout(() => {
            $product_popup.removeClass('-active');
            $product_popup.removeClass('-inactive');
          }, 300);
        }, 2000);
        
        if (typeof updateItemResult == 'function') {
          updateItemResult(_cart);
        }
      })
      .fail(function(error) {
        console.log("Error while updating", error.responseText);
      })
      .always(function() {
        _$item.removeClass('updating');
      });
    }

    return _result;
  },
  shippingBar: function () {
    const shippingController = document.querySelector('[data-shipping-bar]');
    const shippingBar = document.querySelector('[data-shipping-bar]');

    if (shippingController != null && shippingBar != null) {
      const minimumValue = Number(shippingController.getAttribute('data-minimum-value'));
      const cartSubtotal = Number(shippingController.getAttribute('data-cart-subtotal'));
      const displayValue = shippingController.querySelector('[data-shipping-value]');
      const progressBar = shippingController.querySelector('[data-shipping-progress]');

      // Atualiza o valor que falta
      if (displayValue != null) {
        const difValue = minimumValue - cartSubtotal;
        displayValue.innerHTML = formatMoney(difValue);
      }

      // Atualiza barra de progresso
      if (progressBar != null) {
        let percentage;
        if (cartSubtotal > minimumValue) {
          percentage = 100
        } else {
          percentage = (cartSubtotal * 100) / minimumValue;
        }
        progressBar.querySelector('.filling').style.width = `${percentage}%`
      }
    }
  },
  setGiftsSwiper: function () {
    const giftsSlider = document.querySelectorAll('[data-swiper-cart-gifts]');

    if (giftsSlider.length > 0) {
      giftsSlider.forEach(gifts => {  
        const giftsSwiper = new Swiper(gifts, {
          watchOverflow: true,
          loop: false,
          slidesPerView: 'auto',
          spaceBetween: 0,
          speed: 1000,
          scrollbar: {
            el: '.swiper-scrollbar',
            hide: false,
          },
          //swiper lazy load
          preloadImages: false,
          watchVisibility: true,
          lazy: {
            loadPrevNext: true,
            loadOnTransitionStart: true
          }
        });

        giftsSwiper.update();
      });
    }
  },
  setModal: function () {
    $('[data-cart-open]').on('click', function () {
      HeaderCart.loadCart();
      $('.cart-popup').addClass('active');
      $('body').addClass('stop-scrolling');
    });

    $('[data-cart-close]').on('click', function () {
      $('.cart-popup').removeClass('active');
      $('body').removeClass('stop-scrolling');
    });

    $(document).on('click', '[data-action="delete-item-cart"]', function (event) {
      event.preventDefault();

      var $item = $(this).closest('[data-item-cart]');
      var itemId = $item.data('item-id');

      Store.deleteItem(itemId, $item, function (_$item, _cart) {
        HeaderCart.loadCart(_cart);
      });
    });

    initCoupon();
  },
  handleQtyButtons: function () {
    $(document).on('click', '[data-qty]', function() {
      var product_form = $(this).parents('[data-form-product]'),
          quantity_input = product_form.find('input[name="quantity"]:first'),
          current_qty = parseInt(quantity_input.val()),
          button_action = $(this).data('qty'),
          item_form = product_form.data('update-quantity');

      if( isNaN(current_qty) ) {
        current_qty = 1;
      }

      if(button_action == 'min' && current_qty > 1) {
        current_qty--;
      }

      if(button_action == 'plus') {
        current_qty++;
      }

      if( item_form == true ) {
        var _$item = product_form.parents('[data-item-cart]'),
            _itemId = _$item.data('item-id'),
            _newQty = current_qty;
        var _cart = HeaderCart.updateItem(_itemId, _newQty, _$item, function(_cart) {
          HeaderCart.loadCart(_cart);
          quantity_input.val(current_qty);
        });
      } else {
        quantity_input.val(current_qty);
      }
    });
  },
  handleDropdowns: function () {
    $(document).on('click', '[data-cart-dropdown]', function() {
      let $anchor = $(this);
      let $dropdown = $(this).parent().next('.footer-dropdown');

      let $anchor_active = $('[data-cart-dropdown].active');
      let $dropdown_active = $anchor_active.parent().next('.footer-dropdown');

      let $time = 500;

      if($anchor.hasClass('active')){
        $anchor.removeClass('active');

        $dropdown.removeClass('active');
        $dropdown.animate({ height: 0 }, $time);
      } else {
        $anchor_active.removeClass('active');

        $dropdown_active.removeClass('active');
        $dropdown_active.animate({ height: 0 }, $time);

        $anchor.addClass('active');

        var element = $dropdown,
            curHeight = element.height(),
            autoHeight = element.css('height', 'auto').height();
        element.height(curHeight).animate({ height: autoHeight }, $time, () => { element.height('auto') });
        setTimeout(() => {
          $dropdown.addClass('active');
        }, $time);
      }
    });
  },
  init: function(){
    const _this = this;

    Store.getCartCount();
    
    HeaderCart.setModal();
    HeaderCart.handleQtyButtons();
    HeaderCart.handleDropdowns();
    
  }
}

export default HeaderCart
